import { render } from "./Footer.vue?vue&type=template&id=f69a515c&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=f69a515c&lang=scss&scoped=true"

import exportComponent from "D:\\www\\gits\\g-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f69a515c"]])

export default __exports__